/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Ukrainian (Ukraine)
export default {
  'team-central.give-jira-kudos.created.description.flag': 'Наша команда з організації робочого середовища опрацює запит на подарунок. ✨',
  'team-central.give-jira-kudos.created.title.flag': 'Похвалу створено',
  'team-central.give-jira-kudos.creation.failed.description.flag': 'Не вдалося створити похвалу або надіслати подарунок. Спробуйте створити окрему заявку: <a>go/kudos</a>.',
  'team-central.give-jira-kudos.creation.failed.title.flag': 'Щось пішло не так',
  'team-central.give-kudos.button': 'Похвалити',
  'team-central.give-kudos.close-button.label': 'Закрити вікно',
  'team-central.give-kudos.confirm-close.title': 'Підтвердження закриття',
  'team-central.give-kudos.created.description.flag': 'Вашу похвалу надіслано. <a>Переглянути похвалу</a>',
  'team-central.give-kudos.created.title.flag': 'Похвалу створено',
  'team-central.give-kudos.creation.failed.description.flag': 'Не вдалося створити похвалу.',
  'team-central.give-kudos.creation.failed.title.flag': 'Щось пішло не так',
  'team-central.give-kudos.error-icon.label': 'Помилка',
  'team-central.give-kudos.success-icon.label': 'Готово',
  'team-central.give-kudos.unsaved.warning': 'Внесені зміни не збережуться.',
  'team-central.give-kudos.unsaved.warning.cancel': 'Скасувати',
  'team-central.give-kudos.unsaved.warning.close': 'Закрити'
};